import React from 'react';
import { Tooltip, Unstable_Grid2 as Grid, Box } from '@mui/material';

import {
  InfoOutlinedIcon,
  Switches,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@occc-app/design-system';

import {
  loyaltyEnabledMessage,
  loyaltyHeartbeatsOnlyEnabledTooltipMessage,
  mobilePayAtPumpEnabledMessage,
  mobilePaymentMessage,
} from '../copies';

type TextWithTooltipProps = { title: string; tooltip: string };

const TextWithToolTip = ({ title, tooltip }: TextWithTooltipProps) => {
  return (
    <Box sx={{ display: 'flex' }} component='span'>
      {title}
      <Tooltip title={tooltip}>
        <InfoOutlinedIcon color='primary' sx={{ transform: 'translateY(-0.5em)' }} />
      </Tooltip>
    </Box>
  );
};

const LocationDetailsFormContent: React.FC = () => {
  return (
    <Grid container>
      <Grid sm={4} md={3}>
        <ListItem disableGutters disablePadding dense>
          <ListItemIcon>
            <Switches name='siteSystemConfiguration.loyaltyEnabled' data={{}} />
          </ListItemIcon>
          <ListItemText
            primary='Loyalty Enabled'
            secondary={
              <TextWithToolTip
                title='Enable Loyalty Transactions'
                tooltip={loyaltyEnabledMessage}
              />
            }
          />
        </ListItem>
      </Grid>
      <Grid sm={4} md={3}>
        <ListItem disableGutters disablePadding dense>
          <ListItemIcon>
            <Switches name='siteSystemConfiguration.mobileEnabled' data={{}} />
          </ListItemIcon>
          <ListItemText
            primary='Mobile Enabled'
            secondary={
              <TextWithToolTip title='Enable Mobile Transactions' tooltip={mobilePaymentMessage} />
            }
          />
        </ListItem>
      </Grid>
      <Grid xs='auto'>
        <ListItem disableGutters disablePadding dense>
          <ListItemIcon>
            <Switches name='siteSystemConfiguration.loyaltyHeartbeatsOnlyEnabled' data={{}} />
          </ListItemIcon>
          <ListItemText
            primary='Loyalty Heartbeats Only Enabled'
            secondary={
              <TextWithToolTip
                title='Loyalty is enabled, but activity is not allowed (earn/burn)'
                tooltip={loyaltyHeartbeatsOnlyEnabledTooltipMessage}
              />
            }
          />
        </ListItem>
      </Grid>
      <Grid xs='auto'>
        <ListItem disableGutters disablePadding dense>
          <ListItemIcon>
            <Switches name='payAtPumpEnabled' data={{}} />
          </ListItemIcon>
          <ListItemText
            primary='Mobile Pay Enabled'
            secondary={
              <TextWithToolTip
                title='Enable Mobile Pay-at-Pump'
                tooltip={mobilePayAtPumpEnabledMessage}
              />
            }
          />
        </ListItem>
      </Grid>
    </Grid>
  );
};

export default LocationDetailsFormContent;
